import { useCallback, useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"

export function useHashTab(defaultTab: string) {
  const { hash } = useLocation()
  const navigate = useNavigate()

  const extractHash = (h: string) => (h.startsWith("#") ? h.slice(1) : h)
  const initialTab = hash ? extractHash(hash) : defaultTab

  const [activeTab, setActiveTab] = useState(initialTab)

  useEffect(() => {
    if (hash) {
      setActiveTab(extractHash(hash))
    } else {
      setActiveTab(defaultTab)
    }
  }, [defaultTab, hash])

  const handleTabChange = useCallback(
    (id: string) => {
      navigate(`#${id}`, { replace: true })
    },
    [navigate],
  )

  return { activeTab, handleTabChange }
}
